import ReactGA from 'react-ga4'
import Title from '../components/ui/Title'
import Button from '../components/ui/Button'
import '../styles/pages/product.scss'

const Products = () => {
    return (
        <div className='page-container'>
            <Title text='PRODUCTS' />
            <h1 className='product-title-red'>Nintendo Switch™ Deluxe Edition</h1>
            <h2 className='product-availablenow'>Available Now</h2>
            <div className='product-pair'>
                <img src='./img/products/nsw-de.webp' alt='NSW Deluxe Edition Glamshot' />
                <div className='product-links'>
                    <a
                        href='https://www.amazon.com/Legend-Heroes-Trails-Azure-Nintendo-Switch/dp/B09B1QVNT6'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Amazon'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Amazon`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B09B1QVNT6/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Amazon (CA)'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Amazon (CA)`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.gamestop.com/video-games/nintendo-switch/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/390871.html'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='GameStop'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - GameStop`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-nintendo-switch/6481233.p?skuId=6481233'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='BestBuy'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - BestBuy`,
                                })
                            }}
                        />
                    </a>{' '}
                    <a
                        href='https://www.walmart.com/ip/The-Legend-of-Heroes-Trail-to-Azure-Deluxe-Edition-Nintendo-Switch/901905779'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Walmart'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Walmart`,
                                })
                            }}
                        />
                    </a>
                </div>
            </div>
            <h1 className='product-title-blue'>PlayStation®4 Deluxe Edition</h1>{' '}
            <h2 className='product-availablenow'>Available Now</h2>
            <div className='product-pair'>
                <img src='./img/products/ps4-de.webp' alt='PS4 Deluxe Edtion Glamshot' />
                <div className='product-links'>
                    <a
                        href='https://www.amazon.com/Legend-Heroes-Trails-Azure-PlayStation-4/dp/B09B1TBQLB/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Amazon'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Amazon`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.amazon.com/Legend-Heroes-Trails-Azure-PlayStation-4/dp/B09B1TBQLB/ref=sr_1_1?crid=121JZSHUUDTTH&keywords=trails%2Bto%2Bazure&qid=1658790920&sprefix=trails%2Bto%2Bazur%2Caps%2C142&sr=8-1&th=1'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Amazon (CA)'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Amazon (CA)`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.gamestop.com/video-games/playstation-4/products/the-legend-of-heroes-trails-to-azure---playstation-4/390872.html'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='GameStop'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - GameStop`,
                                })
                            }}
                        />
                    </a>

                    <a
                        href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-playstation-4/6481232.p?skuId=6481232'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='BestBuy'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - BestBuy`,
                                })
                            }}
                        />
                    </a>
                    <a
                        href='https://www.walmart.com/ip/The-Legend-of-Heroes-Trails-to-Azure-Deluxe-Edition-PlayStation-4/613736772'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='Walmart'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Walmart`,
                                })
                            }}
                        />
                    </a>
                </div>
            </div>
            <section className='pc-products-section'> <div>
                        {' '}
                <h1 className='product-title-blue'>PC Versions</h1>{' '}
                <h2 className='product-availablenow'>Available Now</h2>
                <iframe
                    src='https://store.steampowered.com/widget/1668520/'
                    width='646'
                    height='190'
                    className='steam'
                ></iframe>
                <div className='product-links-digital'>
                   
                        <a
                            href='https://store.epicgames.com/en-US/p/the-legend-of-heroes-trails-to-azure'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Button
                                text='Epic Games Store'
                                type='solid'
                                onClick={() => {
                                    ReactGA.event({
                                        category: 'Product Link',
                                        action: 'Click',
                                        label: `DE - Digital - Epic Games Store`,
                                    })
                                }}
                            />
                        </a>{' '}
                        <a
                            href='https://www.gog.com/en/game/the_legend_of_heroes_trails_to_azure'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Button
                                text='GOG'
                                type='solid'
                                onClick={() => {
                                    ReactGA.event({
                                        category: 'Product Link',
                                        action: 'Click',
                                        label: `DE - Digital - GOG`,
                                    })
                                }}
                            />
                        </a>
                    </div>{' '}
                </div>
            </section>{' '}
            <h1 className='product-title'>Merchandise</h1>
            <div className='product-pair'>
                <img src='./img/products/acrylic.png' alt='ACRYLIC HERE' className='merch' />
                <div className='product-links'>
                    <a
                        href='https://store.nisamerica.com/the-legend-of-heroes-trails-to-azure/trails-to-azure-azure-legends-acrylic-print'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <Button
                            text='NISA Online Store'
                            type='solid'
                            onClick={() => {
                                ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `Acrylic - NISA`,
                                })
                            }}
                        />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Products
